import React from 'react';
import {
  Box,
  Typography,
  Container,
  Grid,
} from "@mui/material";
import supIcon1 from "../assests/supIcon1.png";
import supIcon2 from "../assests/supIcon2.png";
import supIcon3 from "../assests/supIcon3.png";
import supIcon4 from "../assests/supIcon4.png";

export default function WhatWeDo() {
  return (
    <div>
      <Container maxWidth="xl">
        <Box
          sx={{
            padding: "80px 0",
          }}
        >
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "18px",
                lineHeight: "100%",
                fontWeight: "500",
                fontFamily: `"Quicksand", sans-serif`,
                color: "#008BFF",
                marginBottom: "10px"
              }}
            >
              What We Do
            </Typography>
            <Typography
              sx={{
                fontSize: "40px",
                lineHeight: "100%",
                fontWeight: "700",
                fontFamily: `"Quicksand", sans-serif`,
                color: "#253D4E",
              }}
            >
              Best Supplier for Hospitals, Clinics & NGO and Government Partners
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: "400",
                fontFamily: `"Lato", sans-serif`,
                color: "#211715",
                margin: "15px auto 40px",
                width: "75%"
              }}
            >
              At Life Line Medical Supply, we bring over 40 years of combined experience in global medical sourcing and logistics. Our operations extend across North America, the Middle East, and Europe, connecting healthcare systems, manufacturers, and government institutions through reliable, transparent supply chains.
              We proudly serve hospitals, clinics, and long-term care facilities — and are an approved supplier to the U.S. military and federal agencies, meeting strict compliance and performance standards.

            </Typography>
          </Box>

          <Grid
            container
            spacing={6}
            sx={{
              display: "grid", alignItems: "center",
              gridTemplateColumns:{xs:"repeat(1, 1fr)", sm: "repeat(1, 1fr)", md: "repeat(2, 1fr)", lg: "repeat(2, 1fr)" },
              gap:{xs:"20px", sm: "30px", md: "40px", lg: "40px" },
              "& img": {
                width: "50px",
              },
            }}
          >
            <Grid sx={{width:"100%", height:"100%" }}>
              <Box
                sx={{
                  textAlign: "left",
                  boxShadow: " 0px 20.7px 30.25px 0px #00000012",
                  padding: {xs:"20px", sm: "25px", md: "40px", lg: "40px" },
                  background: "#fff",
                  height:{xs:"auto", sm: "auto", md: "80%", lg: "80%" },
                  "& hr": {
                    width: "79.61px",
                    height: "3.18px",
                    background: "#008BFF",
                    display: "none",
                    margin: "10px 0 15px",
                  },
                }}
              >
                <img src={supIcon1} alt="icon" />
                <Typography
                  sx={{
                    fontSize: "20px",
                    lineHeight: "28.21px",
                    fontWeight: "700",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#252B42",
                    marginTop: "15px",
                    borderBottom:"2px solid #008BFF",
                    width:"fit-content",
                    paddingBottom:"10px",
                  }}
                >
                  Custom Product Development
                </Typography>
                <hr />
                <Typography
                  sx={{
                    fontSize:{xs:"16px", sm: "17px", md: "18px", lg: "20px" },
                    lineHeight:{xs:"22px", sm: "23px", md: "25px", lg: "29.84px" },
                    fontWeight: "400",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#7E7E7E",
                    margin: "15px 0 0",
                    letterSpacing: "0.32px",
                  }}
                >
                  We collaborate with healthcare providers to design and source medical products that fit their precise clinical and operational needs. From concept to delivery, every product is engineered to meet FDA, CE, and ISO standards, ensuring safety, performance, and efficiency.
                </Typography>
              </Box>
            </Grid>
            <Grid sx={{width:"100%", height:"100%" }}>
              <Box
                sx={{
                  textAlign: "left",
                  boxShadow: " 0px 20.7px 30.25px 0px #00000012",
                  padding: {xs:"20px", sm: "25px", md: "40px", lg: "40px" },
                  background: "#fff",
                  height:{xs:"auto", sm: "auto", md: "80%", lg: "80%" },
                  "& hr": {
                    width: "79.61px",
                    height: "3.18px",
                    background: "#008BFF",
                    display: "none",
                    margin: "15px 0",
                  },
                }}
              >
                <img src={supIcon2} alt="icon" />
                <Typography
                  sx={{
                    fontSize: "20px",
                    lineHeight: "28.21px",
                    fontWeight: "700",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#252B42",
                    marginTop: "15px",
                    // minHeight: "57px",
                    borderBottom:"2px solid #008BFF",
                    width:"fit-content",
                    paddingBottom:"10px",
                  }}
                >
                  Diverse Products from Trusted Global Sources
                </Typography>
                <hr />
                <Typography
                  sx={{
                    fontSize: {xs:"16px", sm: "17px", md: "18px", lg: "20px" },
                    lineHeight: {xs:"22px", sm: "23px", md: "25px", lg: "29.84px" },
                    fontWeight: "400",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#7E7E7E",
                    margin: "15px 0 0",
                    letterSpacing: "0.32px",
                  }}
                >
                  Our supplier network spans China, Canada, Mexico, Germany, Jordan, the United Kingdom, and the United States, giving clients access to a robust and diversified portfolio.
                  From essential medical disposables to specialized diagnostic equipment, we secure competitive pricing and stable supply lines — even during market disruptions.
                </Typography>
              </Box>
            </Grid>
            <Grid sx={{width:"100%", height:"100%" }}>
              <Box
                sx={{
                  textAlign: "left",
                  boxShadow: " 0px 20.7px 30.25px 0px #00000012",
                  padding: {xs:"20px", sm: "25px", md: "40px", lg: "40px" },
                  background: "#fff",
                  height:{xs:"auto", sm: "auto", md: "80%", lg: "80%" },
                  "& hr": {
                    width: "79.61px",
                    height: "3.18px",
                    background: "#008BFF",
                    display: "none",
                    margin: "15px 0",
                  },
                }}
              >
                <img src={supIcon3} alt="icon" />
                <Typography
                  sx={{
                    fontSize: "20px",
                    lineHeight: "28.21px",
                    fontWeight: "700",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#252B42",
                    marginTop: "15px",
                    // minHeight: "57px",
                    borderBottom:"2px solid #008BFF",
                    width:"fit-content",
                    paddingBottom:"10px",
                  }}
                >
                  Optimal Supply Chain & Cost Control
                </Typography>
                <hr />
                <Typography
                  sx={{
                    fontSize:{xs:"16px", sm: "17px", md: "18px", lg: "20px" },
                    lineHeight: {xs:"22px", sm: "23px", md: "25px", lg: "29.84px" },
                    fontWeight: "400",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#7E7E7E",
                    margin: "15px 0 0",
                    letterSpacing: "0.32px",
                  }}
                >
                  We manage every stage of the procurement process, from factory coordination to final delivery.
                  Our logistics systems are optimized for cost efficiency, speed, and regulatory compliance, providing real-time visibility and dependable delivery to healthcare and military facilities worldwide.
                </Typography>
              </Box>
            </Grid>
            <Grid sx={{width:"100%", height:"100%" }}>
              <Box
                sx={{
                  textAlign: "left",
                  boxShadow: " 0px 20.7px 30.25px 0px #00000012",
                  padding: {xs:"20px", sm: "25px", md: "40px", lg: "40px" },
                  background: "#fff",
                  height:{xs:"auto", sm: "auto", md: "80%", lg: "80%" },
                  "& hr": {
                    width: "79.61px",
                    height: "3.18px",
                    background: "#008BFF",
                    display: "none",
                    margin: "15px 0",
                  },
                }}
              >
                <img src={supIcon4} alt="icon" />
                <Typography
                  sx={{
                    fontSize: "20px",
                    lineHeight: "28.21px",
                    fontWeight: "700",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#252B42",
                    marginTop: "15px",
                    // minHeight: "57px",
                    borderBottom:"2px solid #008BFF",
                    width:"fit-content",
                    paddingBottom:"10px",
                  }}
                >
                  Quality Assurance
                </Typography>
                <hr />
                <Typography
                  sx={{
                    fontSize:{xs:"16px", sm: "17px", md: "18px", lg: "20px" },
                    lineHeight:{xs:"22px", sm: "23px", md: "25px", lg: "29.84px" },
                    fontWeight: "400",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#7E7E7E",
                    margin: "15px 0 0",
                    letterSpacing: "0.32px",
                  }}
                >
                  Every item we deliver passes through a multi-layered inspection, certification, and verification process.
                  Our QA team monitors product traceability and documentation at every step — ensuring full alignment with international healthcare and defense procurement standards.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
}
